import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-banner-page',
    templateUrl: './banner-page.component.html',
    styleUrls: ['./banner-page.component.scss']
})
export class BannerPageComponent implements OnInit {
    public identity: number = null;

    public exampleCode: string =
`<say-banner [ident]='identity'>
    <div>Your banner identity is {{identity}}
        <a class='say-link' href='' target='_blank'>Privacy Link</a>
    </div>
</say-banner>`;

    constructor() {
    }

    ngOnInit() {
        this.identity = Math.floor(Math.random() * 10001);
        console.log('banner identity:', this.identity);
    }

}
